import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
import LazyLoad from 'react-lazyload';
const Facilities = () => {
  useEffect(() => {
    document.title = 'Facilities -  Sacred Heart School, Ballia - U.P.';  
}, []); 
    return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Facilities </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Academic</li>
                            <li>|</li>
                            <li> Facilities </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
               <div className="row facilities"> 
               <div className="col-12">
                     <h3 className="subhead">Library</h3>
                     <div className="facilities-img1 left-block">
                     <LazyLoad><img className="img-fluid" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/faci1.jpg" alt="SHSB"/></LazyLoad> 
                     </div>
                     <p className="first-letter">The school library provides a model for inquiry learning and building knowledge and confidence in seeking and processing information. The school library is pivotal to developing 21st century learners.</p>
               </div>
               <hr/>
                   <div className="col-12">
                     <h3 className="subhead">Smart Classes</h3>
                     <div className="facilities-img right-block">
                     <LazyLoad><img className="img-fluid" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/faci2.jpg" alt="SHSB"/></LazyLoad>
                     </div>
                     <p class="first-letter">All the classrooms in the School are equipped with Smart Boards. We all know how helpful it is to remember something that is taught visually to us rather than the one that is read through pages after pages. Just imagine, how beneficial would it be for students to understand a chapter visually in class. The concept of smart class education is indeed a blessing to the students. Technology is changing the way life functions and if it's for the good, then why not go for it!</p>
                    <p> Smart classes use all interactive modules like videos and presentations and these visually attractive methods of teaching become appealing to students who are already struggling with the traditional method of teaching in a classroom. In fact, smart classes are almost like watching movies as sometimes, animated visuals are used to teach a point. This kind of visual is both eye-catching and young students can easily relate with them. This is because the audio-visual senses of students are targeted and it helps the students store the information fast and more effectively.</p>
                     <br/>
                   </div>
               <hr/>
               <div className="col-12">
                     <h3 className="subhead">Computer Lab</h3>
                     <div className="facilities-img1 left-block">
                     <LazyLoad><img className="img-fluid" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/faci3.jpg" alt="SHSB"/></LazyLoad>
                     </div>
                     <p class="first-letter">Trained and experienced teachers provide both theoretical and practical lessons for students to help them navigate a rapidly changing technology driven world.</p>
                     <br/>
               </div>
               <hr/>
                   <div className="col-12">
                     <h3 className="subhead">Science Lab</h3>
                     <div className="facilities-img right-block">
                     <LazyLoad><img className="img-fluid" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/faci4.jpg" alt="SHSB"/></LazyLoad>
                     </div>
                     <p class="first-letter">Three science laboratories provide requisite hands-on experience which is the heart of science teaching. Science teachers along with the lab assistant plan various demonstrations and experiments to ignite the curiosity and inculcate a scientific temperament in the students.</p>
                     <br/>
                   </div>
               <hr/>
               <div className="col-12">
                     <h3 className="subhead"> Teachers Resource Centre</h3>
                     <div className="facilities-img1 left-block">
                       <LazyLoad><img className="img-fluid" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/faci5.jpg" alt="SHSB"/></LazyLoad>
                     </div>
                     <p class="first-letter">One of the exclusive features of our school is the Teachers Resource Centre (TRC). The Centre has computers with broadband internet facilities and serves as a space for teachers to interact on a regular basis. It supports and facilitates in-service professional development of faculty. To keep abreast of new technology the school also owns an informational and educational CD library.</p>
                     <br/>
               </div> 
             </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Facilities